import React, { FC, Fragment, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Backdrop from "@material-ui/core/Backdrop";
import SpeedDial from "@material-ui/lab/SpeedDial";
import SpeedDialIcon from "@material-ui/lab/SpeedDialIcon";
import SpeedDialAction from "@material-ui/lab/SpeedDialAction";
import PersonIcon from "@material-ui/icons/Person";
import DirectionsCarIcon from "@material-ui/icons/DirectionsCar";
import FolderIcon from "@material-ui/icons/Folder";
import { useRedirect } from "Helpers/RedirectHelper";
import { useTranslation } from "Providers/TranslationProvider";

interface Props {
	openScheduleResourceModal: () => void;
	openSchedulePhaseModal: () => void;
}

const MainActionButton: FC<Props> = (props) => {
	const classes = useStyles();
	const [isOpen, setIsOpen] = useState(false);
	const redirect = useRedirect();
	const { t } = useTranslation();

	const actions = [
		{
			icon: <FolderIcon />,
			tooltip: t("MainActionButton_AddProject"),
			onClick: () => {
				setIsOpen(false);
				props.openSchedulePhaseModal();
			},
		},
		{
			icon: <DirectionsCarIcon />,
			tooltip: t("MainActionButton_AddScheduleResource"),
			onClick: () => {
				setIsOpen(false);
				props.openScheduleResourceModal();
			},
		},
		{
			icon: <PersonIcon />,
			tooltip: t("MainActionButton_AddEmployee"),
			onClick: () => {
				setTimeout(() => {
					redirect("settings/company-employees");
				}, 100);
			},
		},
	];

	function renderActions() {
		return actions.map((action, index) => (
			<SpeedDialAction
				key={index}
				icon={action.icon}
				tooltipTitle={<span className={classes.tooltip}>{action.tooltip}</span>}
				tooltipOpen
				FabProps={{ size: "large" }}
				onClick={action.onClick}
			/>
		));
	}

	return (
		<Fragment>
			<Backdrop
				open={isOpen}
				className={classes.backdrop}
				onClick={() => setIsOpen(false)}
			/>
			<SpeedDial
				ariaLabel="SpeedDial tooltip example"
				className={classes.speedDial}
				icon={<SpeedDialIcon />}
				onClick={() => {
					setIsOpen(!isOpen);
				}}
				open={isOpen}
			>
				{renderActions()}
			</SpeedDial>
		</Fragment>
	);
};

export default MainActionButton;

const useStyles = makeStyles({
	backdrop: {
		zIndex: 1000,
	},
	speedDial: {
		position: "fixed",
		bottom: 96,
		right: 24,
	},
	tooltip: {
		whiteSpace: "nowrap",
	},
});
